<script setup lang="ts">
import { computed, ref } from "vue";
import PedidosListado from "./components/PedidosListado.vue";
import PedidosFiltros from "./components/PedidosFiltros.vue";
import GestionPedidos from "./components/GestionPedidos.vue";
import Button from "../../base-components/Button/Button.vue";
import { userUserStore } from "../../stores/user";

const showFormAgregar = ref(false);
const showFormFiltro = ref(false);
const userStore = userUserStore();
const vista = computed<"pedidos" | "gestion">({
  get: () => userStore.pedidosVistaSector ?? "pedidos",
  set: value => userStore.setPedidosVistaSector(value)
});
</script>

<template>
  <div class="mt-4">
    <!-- Tabs Pedidos / Gestión de pedidos -->
    <div
      class="inline-flex rounded-full bg-slate-100 p-1 shadow-sm border border-slate-200"
    >
      <button
        type="button"
        class="px-4 py-1.5 text-sm font-medium rounded-full transition-all"
        :class="
          vista === 'pedidos'
            ? 'bg-white text-slate-900 shadow-sm'
            : 'text-slate-500 hover:text-slate-700'
        "
        @click="vista = 'pedidos'"
      >
        Pedidos
      </button>
      <button
        type="button"
        class="px-4 py-1.5 text-sm font-medium rounded-full transition-all"
        :class="
          vista === 'gestion'
            ? 'bg-white text-slate-900 shadow-sm'
            : 'text-slate-500 hover:text-slate-700'
        "
        @click="vista = 'gestion'"
      >
        Gestión de pedidos
      </button>
    </div>
  </div>

  <template v-if="vista === 'pedidos'">
    <div v-if="!showFormFiltro" class="mt-4">
      <Button
        class="w-full border-slate-300"
        variant="secondary"
        size="lg"
        @click="
          () => {
            showFormFiltro = true;
          }
        "
      >
        <div class="p-3 flex items-center">
          <i class="fas fa-arrow-left mr-2"></i>
          <h2 class="text-lg" style="text-align: left">Filtros</h2>
        </div>
      </Button>
    </div>
    <div v-else class="mt-5">
      <PedidosFiltros
        @cerrar="
          () => {
            showFormFiltro = false;
          }
        "
      />
    </div>
    <PedidosListado />
  </template>

  <template v-else>
    <GestionPedidos />
  </template>
</template>
